var map = {
	"./goldcoin/inset-bg.jpg": 25790,
	"./memetown/inset-bg.jpg": 12018,
	"./reflection/inset-bg.jpg": 429,
	"./tapcoin/inset-bg.jpg": 62836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4723;